// True when requestAnimationFrame is healthy (real deployed site).
// False when the editor preview iframe throttles rAF (visibility-hidden),
// in which case framer-motion animations would never progress — components
// use this to render visible-by-default instead.
export const motionOk = typeof window !== "undefined" && window.__rafOk !== false;
